import React from 'react';
import { useAuth } from './AuthContext';
import PortfolioDashboard from './portfolio-dashboard';
import LoginPage from './LoginPage';
import ErrorBoundary from './ErrorBoundary';

function App() {
  const { user, loading, signOut } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-950 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      {user ? <PortfolioDashboard user={user} onLogout={signOut} /> : <LoginPage />}
    </ErrorBoundary>
  );
}

export default App;